const IsValidDate = (date: unknown) => {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(Number(date));
};

export default IsValidDate;
